export default function searchHistoryFactory(houseService) {
    return {
        currentSelectedSearch: null,
        ViewType: null,
        houseService: null,
        storeUserSearch: function() {
            var HouseServiceSnapshot = angular.copy(houseService);

            this.history.push(HouseServiceSnapshot);

            // return $http.post(url, registration).then(function (response) {
            //     return response;
            // });
        },

        history: []
    };
}
